import React from 'react';
import {TextField, Button, Box, CircularProgress} from '@mui/material';

interface AuthFormProps {
    loading: boolean | null;
    onSubmit: (data: { email: string; password: string }) => void;
    buttonText: string;
    error: string | null;
}

const AuthForm: React.FC<AuthFormProps> = ({onSubmit, buttonText, loading, error}) => {
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit({email, password});
    };

    return (
        <Box className='authFileds' component="form" onSubmit={handleSubmit} sx={{mt: 1}}>
            <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Пароль"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            {loading === true ?
                <Box sx={{mt: 2, display: 'flex', justifyContent: 'center', height: 50}}>
                    <CircularProgress  style={{color: '#3a485b'}}/>
                </Box>
                :
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{mt: 2, mb: 0, height: 50, background: '#3a485b'}}
                >
                    {buttonText}
                </Button>
            }
        </Box>
    );
};

export default AuthForm;
